// removed by extract-text-webpack-plugin
module.exports = {"ba-hr":"magazines_2NqHT","ba-relative":"magazines_1OT7U","font-text":"magazines_2rziX","mg-l":"magazines_2OIu0","text-dashboard":"magazines_2DBJi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/ContentEditor/editors/TextContent/styles.scss
// module id = 1068
// module chunks = 1